import { render, staticRenderFns } from "./widgetGauge.vue?vue&type=template&id=941e839e&scoped=true&"
import script from "./widgetGauge.vue?vue&type=script&lang=js&"
export * from "./widgetGauge.vue?vue&type=script&lang=js&"
import style0 from "./widgetGauge.vue?vue&type=style&index=0&id=941e839e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941e839e",
  null
  
)

export default component.exports